<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <neighborhood-create-or-update v-model="neighborhood" :errors="errors"></neighborhood-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
        <v-table
            ref="table"
            :items-provider="provider"
            :fields="fields"
            :add-callback="createNew"
            :buttons="buttons"
            search
            pagination="server">
        </v-table>
    </b-card>
</template>

<script>
    import { BCard } from 'bootstrap-vue';
    import SystemDataApi from '@/api/system-data'
    import NeighborhoodCreateOrUpdate from './components/NeighborhoodCreateOrUpdate.vue'

    export default {
        components : {
            BCard,
            NeighborhoodCreateOrUpdate
        },
        data() {
            return {
                fields:[
                    {name:'İl',key:'ProvinceName',thClass:'w-33'},
                    {name:'İlçe',key:'DistrictName',thClass:'w-33'},
                    {name:'Mahalle',key:'Name',thClass:'w-34'}
                ],
                buttons : [
                    { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                    { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                ],
                neighborhood: {
                    Id : null,
                    Name : null,
                    CountryId : null,
                    ProvinceId : null,
                    DistrictId : null,
                },
                errors:{},
                    editing: false,
                    loading: false
                }
        },
        methods: {
            provider(data) {
                return SystemDataApi.NeighborhoodOperations.Table(data)
            },
            clearForm(){
                this.editing = false
                this.neighborhood.Id = null
                this.neighborhood.Name = null
                this.neighborhood.CountryId = null
                this.neighborhood.ProvinceId = null
                this.neighborhood.DistrictId = null
            },
            createNew(){
                this.clearForm()
                this.$showModal('create-or-update')
            },
            edit(item){
                this.clearForm()
                this.editing = true
                this.neighborhood.Id = item.Id
                this.neighborhood.Name = item.Name
                this.neighborhood.CountryId = item.CountryId
                this.neighborhood.DistrictId = item.DistrictId
                this.neighborhood.ProvinceId = item.ProvinceId
                this.$showModal('create-or-update')
            },
            createOrUpdate(){
                this.loading = true
                SystemDataApi.NeighborhoodOperations.CreateOrUpdate(this.editing,this.neighborhood)
                .then(res=>{
                    if(res.data.Success) {
                        this.$refs.table.refresh()
                        this.$hideModal('create-or-update')
                    }
                    this.$result(res)
                    this.loading = false
                })
                .catch(err=>{
                    this.$result(null,err)
                    this.loading = false
                })
            },
            delete(item){
                this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli mahalle bilgisini silecektir ve geri alınamaz.`).then(result=>{
                    if(result){
                        SystemDataApi.NeighborhoodOperations.Delete(item.Id).then(res=>{
                            if(res.data.Success) {
                                this.$refs.table.refresh()
                            }
                            this.$result(res)
                        }).catch(err=>{
                            this.$result(null,err)
                        })
                    }
                })
            },
        }
    }
</script>